import React, { Component } from 'react'
import styled from 'styled-components'
import { darken } from 'polished'

import Color from 'helpers/Color'

// TabButton's z-index must be lower than Content's
const TabButton = styled.span`
  z-index: 1;
  display: inline-block;
  font-size: 1.5em;
  background-color: ${({selected}) => selected ? Color.white : 'none'};
  border-radius: 10px 10px 0 0;
  padding: 10px 20px 20px 20px;
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: ${darken(0.03, Color.white)};
  }

  &:active {
    background-color: ${darken(0.05, Color.white)};
  }
`
const Wrapper = styled.div`
  width: 100%;
`
const Content = styled.div`
  z-index: 2;
  position: relative;
  top: -10px;
  margin-bottom: -10px;
`

class Tabs extends Component {
  state = {
    selected: 0,
  }

  handleClick(index, callback) {
    this.setState({
      selected: index,
    })
    if (callback) callback()
  }

  render () {
    const { panes } = this.props
    const { selected } = this.state

    const buttons = panes.map((pane, index) => (
      <TabButton
        key={index}
        selected={index === this.state.selected}
        onClick={() => this.handleClick(index, pane.onClick)}
      >
        {pane.title}
      </TabButton>
    ))

    return (
      <Wrapper>
        {buttons}
        <Content>
          {panes[selected].content}
        </Content>
      </Wrapper>
    )
  }
}

export default Tabs



// WEBPACK FOOTER //
// ./src/components/UI/Tabs.jsx